module.exports = __webpack_public_path__ + "img/blank-comic-book_B098CX9YQ3.edc36b27.jpg";